export default __webpack_public_path__ + "static/media/werender_metaverse.638767bf.jpg";